// global
import React, { Component } from 'react';
import { Switch, Route } from 'react-router';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
// local
// import the redux store
import { store, history } from 'app/redux/store';
// pages
import Login from 'app/ui/pages/login/Login';
import Home from 'app/ui/pages/home/Home';
// import the private router
import PrivateRoute from 'app/router/PrivateRoute';
// css
import './Root.css';

class Root extends Component {
    render() {
        return (
            <Provider store={store}>
                <ConnectedRouter history={history}>
                    <Switch>
                        <Route exact path="/login" component={Login} />
                        <PrivateRoute path="/" component={Home} />
                    </Switch>
                </ConnectedRouter>
            </Provider>
        );
    }
}

export default Root;
